import thunk from 'redux-thunk';
export const middlewares = [
  thunk,
  // to be activated to dev only - logger
];
